import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=10f59756&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=10f59756&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f59756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f59756')) {
      api.createRecord('10f59756', component.options)
    } else {
      api.reload('10f59756', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=10f59756&scoped=true", function () {
      api.rerender('10f59756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/questionnaire/preview.vue"
export default component.exports